import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bf-login-form" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "login-input-email",
  class: "form-label"
}, "E-Mail-Adresse", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "login-input-password",
  class: "form-label"
}, "Passwort", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "login-input-remember"
}, "Angemeldet bleiben.", -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "d-none"
}, "Anmelden", -1)
const _hoisted_10 = { class: "mt-3 mb-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Ich habe mein ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_13 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Du hast noch kein Konto? Hier geht es zur ")
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Registrierung")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(".")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldError = _resolveComponent("FieldError")!
  const _component_PasswordResetRequestModal = _resolveComponent("PasswordResetRequestModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      novalidate: "",
      ref: "form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.email || false}]),
          id: "login-input-email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
        }, null, 2), [
          [
            _vModelText,
            _ctx.form.email,
            void 0,
            { trim: true }
          ]
        ]),
        _createVNode(_component_FieldError, {
          errors: _ctx.errors.email || []
        }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.password || false}]),
          id: "login-input-password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event))
        }, null, 2), [
          [
            _vModelText,
            _ctx.form.password,
            void 0,
            { trim: true }
          ]
        ]),
        _createVNode(_component_FieldError, {
          errors: _ctx.errors.password || []
        }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "d-none form-check-input",
          id: "login-input-remember",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.remember) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.remember]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("a", {
        href: "#",
        class: _normalizeClass(["btn", {'btn-primary': !_ctx.success, 'btn-success': _ctx.success}]),
        disabled: _ctx.loading || _ctx.success,
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createTextVNode(_toDisplayString(!_ctx.success ? 'Anmelden' : 'Anmelden erfolgreich') + " ", 1),
        _createElementVNode("i", {
          class: _normalizeClass(["fa fa-sign-in fa-fw", {'fa-sign-in-alt': !(_ctx.loading || _ctx.success), 'fa-spinner fa-spin': _ctx.loading || _ctx.success}])
        }, null, 2)
      ], 10, _hoisted_8),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.passwordResetRequestModalShown = true), ["prevent"]))
        }, "Passwort vergessen"),
        _hoisted_12
      ])
    ], 544),
    (_ctx.showRegisterLink)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
          _createElementVNode("small", null, [
            _hoisted_14,
            _createElementVNode("a", { href: _ctx.registerUrl }, _hoisted_18, 8, _hoisted_15),
            _hoisted_19
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PasswordResetRequestModal, {
      shown: _ctx.passwordResetRequestModalShown,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.passwordResetRequestModalShown = false))
    }, null, 8, ["shown"])
  ]))
}